import { compact } from 'lodash';

import {
  entityPlugin as Entity,
  errorPlugin as Error,
} from '@zapier/toolbox-redux-framework';

import Auth from 'app/auth';
import Billing from 'app/billing';
import CompanyAccount from 'app/company-account';
import Developer from 'app/developer';
import ExpertInvite from 'app/expert-invite';
import GetHelp from 'app/get-help';
import IWasHere from 'app/i-was-here';
import Login from 'app/login';
import Min from 'app/min';
import OpenSource from 'app/opensource';
import Partner from 'app/partner';
import Refresh from 'app/refresh';
import Rover from 'app/rover';
import Service from 'app/service';
import Team from 'app/team';
import TeamAccount from 'app/team-account';
import TeamExperts from 'app/team-experts';
import Test from 'app/test';
import Track from 'app/track';
import TwoFactor from 'app/two-factor';
import Unsubscribe from 'app/unsubscribe';
import UseCase from 'app/use-case';
import ZapMover from 'app/zap-mover';
import Zapbook from 'app/zapbook';
import ZapTemplates from 'app/zap-templates';
import safeExtend from 'app/common/utils/safeExtend';

const appPlugins = [
  Track,
  Auth,
  Service,
  Error,
  ExpertInvite,
  GetHelp,
  Min,
  Login,
  TwoFactor,
  Entity,
  ZapMover,
  Team,
  CompanyAccount,
  TeamAccount,
  TeamExperts,
  Developer,
  Zapbook,
  Billing,
  OpenSource,
  Partner,
  Refresh,
  Rover,
  Test,
  Unsubscribe,
  IWasHere,
  UseCase,
  ZapTemplates,
];

export default function () {
  return {
    all: appPlugins,

    get routes() {
      // Grab all the route objects.
      const routeArgs = compact(appPlugins.map(plugin => plugin.routes));

      // Make sure they're all unique.
      const safeExtendRouteArgs = [{}].concat(routeArgs);

      return safeExtend(...safeExtendRouteArgs);
    },

    get reducers() {
      return appPlugins.map(plugin => plugin.reducers);
    },

    get actionsTypes() {
      return appPlugins.map(plugin => plugin.actionTypes);
    },
  };
}
